<template>
  <section class="hd-wap-share">
    <template v-if="id !='' && id != undefined && id !=null ">
      <video :src="obj.url" controls="controls" id="video" ref="video" x-webkit-airplay="allow" muted playsinline>
        您的浏览器不支持 video 标签。
      </video>
      <p class="title f16">{{obj.name}}</p>
      <div class="bt">
        <img src="~assets/images/share/image_text.png" alt="">
      </div>
      <section class="content">
        <div class="code">
          <img :src="obj.qrUrl" alt="">
        </div>
        <p class="f13">长按二维码,下载<span style="color: #0193e6;">海渡职校</span>APP</p>
        <p class="f13">观看完整视频</p>
      </section>
      <div class="tip" v-show="playOver" @click="resetVideo">
        <div class="layer"></div>
        <div class="body">
          <p class="f16">试看结束</p>
          <p class="f16">请下载海渡职校APP继续观看</p>
        </div>
      </div>
    </template>
    <template v-else>
      <h1 style="text-align: center;margin-top:50%;">您的链接缺少课时信息,请确认后重试</h1>
    </template>
  </section>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      id: this.$route.query.id,
      obj: {
        url: '',
        name: '',
        qrUrl: ''
      },
      playOver: false,
      video: null
    }
  },
  mounted() {


  },
  created() {
    this.fetchVideo();
  },
  methods: {
    fetchVideo() {
      let that = this;
      this.service.scanCourseCode({
        id: this.id
      }).then(result => {
        if (result.success) {
          this.obj = result.data;
          this.$nextTick(() => {
            this.video = this.$refs.video;
            this.video.ontimeupdate = function(e) {
              if (e.target.currentTime >= (3 * 60)) { //三分钟停止播放
                console.log(`试看时间结束`)
                e.target.pause();
                that.playOver = true;
                return false;
              }
            }
          });
        }
      })
    },
    resetVideo() {
      this.playOver = false;
      this.video.currentTime = 0;
    },
    isAndroid() {
      var u = navigator.userAgent;
      return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    },
  }
}

</script>
<style lang="scss" scoped>
#video {
  width: 100%;
  height: 5.6rem;
}

.title {
  width: 100%;
  height: 1.333rem;
  padding-left: 0.333rem;
  line-height: 1.333rem;
  border-bottom: 1px solid #eeeeee;
  color: #3a3f43;
}

.bt {
  width: 4.533rem;
  margin: 0.667rem auto 0.267rem;
  img {
    width: 100%;
  }
}

.tip {
  width: 100%;
  height: 5.6rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 200;
    background: rgba(0, 0, 0, .2);
  }
  .body {
    position: absolute;
    width: 100%;
    z-index: 201;
    color: #fff;
    top: 1.867rem;
    text-align: center;
    p {
      margin-bottom: 0.267rem;
    }
  }
}

.content {
  width: 100%;
  height: 6.373rem;
  background: url(~assets/images/share/img_bg.png) center no-repeat;
  background-size: cover;
  background-color: #fff;
  text-align: center;
  padding-top: 0.6rem;
  margin-bottom: 0.733rem;
  .code {
    width: 4.333rem;
    height: 4.333rem;
    border: 1px solid #202020;
    margin: 0 auto;
    padding: 0.267rem;
    img {
      width: 100%;
    }
  }
  p {
    margin-top: 0.267rem;
    color: #626b73;
  }
}
video::-internal-media-controls-download-button {
    display:none;
}

video::-webkit-media-controls-enclosure {
    overflow:hidden;
}

video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
}

</style>



// WEBPACK FOOTER //
// Share.vue?6327704d